import { useEffect } from 'react'
import { Errcode } from 'src/constants/errcode'
import { setExplorerFileList } from 'src/store/Reducer/socket/ExplorerfileListSlice'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { AppThunk } from 'src/store/store'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useTranslation } from 'react-i18next'
import { setExplorerFileDownCancelToggle, setExplorerFileListLoading } from 'src/store/Reducer/page/explorerPageSlice'

import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'

const useExplorerDetailEventBus = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()

  useEffect(() => {
    const ExplorerFileListResponseListener = eventBus.subscribe<ResponseDataBody.ExplorerFileList>(
      Cmdtypes.EXPLORER_FILE_LIST,
      handleExplorerFileListResponse,
    )
    const ExplorerFolderInnerResponseListener =
      eventBus.subscribe<ResponseDataBody.ExplorerFileList>(
        Cmdtypes.EXPLORER_FOLDER_INNER,
        handleExplorerFolderInnerResponse,
      )
    const ExplorerFileDownloadResponseListener =
      eventBus.subscribe<ResponseDataBody.ExplorerFileDownData>(
        Cmdtypes.EXPLORER_FILE_DOWNLOAD_REQUEST,
        (message: ResponseDataType<ResponseDataBody.ExplorerFileDownData>) =>
          dispatch(handleExplorerFileDownloadResponse(message)),
      )
    return () => {
      ExplorerFileListResponseListener.unsubscribe()
      ExplorerFolderInnerResponseListener.unsubscribe()
      ExplorerFileDownloadResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleExplorerFileListResponse = (
    message: ResponseDataType<ResponseDataBody.ExplorerFileList>,
  ) => {
    const { Body, Header } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setExplorerFileList(Body))
    } else console.error(Header)
    dispatch(setExplorerFileListLoading(false))
  }

  const handleExplorerFolderInnerResponse = (
    message: ResponseDataType<ResponseDataBody.ExplorerFileList>,
  ) => {
    const { Header, Body } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setExplorerFileList(Body))
    } else console.error(Header)
    dispatch(setExplorerFileListLoading(false))
  }

  const handleExplorerFileDownloadResponse = (
    message: ResponseDataType<ResponseDataBody.ExplorerFileDownData>,
  ): AppThunk => {
    return async (dispatch, getState) => {
      const { ExplorerFileDownCancelToggle } = getState().ExplorerPage
      const { Header, Body } = message.responseData
      const { File } = Body
      if (ExplorerFileDownCancelToggle) {
        dispatch(setExplorerFileDownCancelToggle(false))
        return
      } else {
        if (Header.ErrCode === Errcode.SUCCESS) {
          dispatch(
            setModalItems({
              type: 'backupData',
              text: `${t('MODAL.BACK_UP.SUCCESS', {
                defaultValue: 'The, download will start in a moment.',
              })}`,
            }),
          )
          const hiddenElement = document.createElement('a')
          hiddenElement.href = File
          hiddenElement.target = '_blank'
          hiddenElement.download = `MFinder_(${new Date()})`
          hiddenElement.click()
          URL.revokeObjectURL(File)

          //todo : 실제로 어떤 역할을 위해 쓰이고 있진 않음
          // dispatch(SocketSender(Cmdtypes.EXPLORER_FILE_DOWNLOAD_COMPLETE))
        } else {
          dispatch(
            setModalItems({
              type: 'alert',
              text: Header.ErrMsg,
            }),
          )
        }
      }
    }
  }
}

export default useExplorerDetailEventBus
